export interface Comic {
  id: number;
  title: string;
  author: string;
  coverSeq: string;
  category: string;
  rating: number;
  description: string;
  status: string;
  chapters: number;
  views: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    coverSeq: 'comic-cover-01',
    category: 'action',
    rating: 9.8,
    description: '在一个怪物与人类共存的世界中，最弱的E级猎人成振宇在一次地下城任务中濒临死亡，却意外获得了"系统"的力量。从此他成为了唯一可以"升级"的猎人，一步步走向最强之路。这是一部现象级韩国漫画，以震撼的战斗场面和紧张刺激的剧情俘获全球读者。',
    status: '连载中',
    chapters: 201,
    views: '1.2亿',
    tags: ['系统', '逆袭', '热血', '战斗'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '女神降临',
    author: '喵呜',
    coverSeq: 'comic-cover-02',
    category: 'love',
    rating: 9.5,
    description: '因外貌自卑的女孩林周京，通过化妆技巧华丽变身为校园女神。然而她必须时刻小心隐藏自己的素颜，同时还要应对两位帅气男生的感情纠葛。这部甜中带虐的校园恋爱漫画，讲述了关于自信与真爱的动人故事。',
    status: '已完结',
    chapters: 178,
    views: '9800万',
    tags: ['校园', '恋爱', '化妆', '三角恋'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverSeq: 'comic-cover-03',
    category: 'fantasy',
    rating: 9.7,
    description: '金独子是一个普通上班族，唯一兴趣是追一部连载了十余年的网络小说。当小说迎来最终话的那天，世界突然变成了小说中的场景。作为唯一知道故事结局的人，他能否利用这份"全知"在末日中生存下去？',
    status: '连载中',
    chapters: 189,
    views: '8500万',
    tags: ['末世', '异能', '系统', '逆袭'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '再婚皇后',
    author: 'Alpha Tart / Sumpul',
    coverSeq: 'comic-cover-04',
    category: 'fantasy',
    rating: 9.4,
    description: '娜维埃是东方帝国的完美皇后，却因不孕问题被皇帝冷落。当皇帝带回一个名叫拉丝塔的情妇后，娜维埃提出离婚，决定前往西方王国开始新的人生。经典的古风复仇与逆袭故事，画风华丽精美。',
    status: '已完结',
    chapters: 162,
    views: '7200万',
    tags: ['古风', '逆袭', '宫斗', '恋爱'],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '看脸时代',
    author: '朴泰俊',
    coverSeq: 'comic-cover-05',
    category: 'action',
    rating: 9.3,
    description: '因外貌被霸凌的朴亨硕，某天醒来发现自己拥有了一个完美帅气的新身体。他可以在两个身体之间切换，体验着截然不同的人生。但他很快发现，外表并不能解决一切问题。一部深刻探讨社会现实与自我认同的作品。',
    status: '连载中',
    chapters: 450,
    views: '1.5亿',
    tags: ['校园', '社会', '双重视角', '成长'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    coverSeq: 'comic-cover-06',
    category: 'horror',
    rating: 9.6,
    description: '在经历家庭悲剧后，车贤秀搬进一栋名为"绿色家园"的破旧公寓楼。然而公寓外的世界正被一种神秘病毒侵袭，人类开始变成可怕的怪物。贤秀必须在狭小的公寓空间中与幸存者协作求生，同时抵抗自身的感染变化。',
    status: '已完结',
    chapters: 140,
    views: '6300万',
    tags: ['末世', '怪物', '悬疑', '人性'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverSeq: 'comic-cover-07',
    category: 'fantasy',
    rating: 9.5,
    description: '一位现代女孩穿越成为小说中的公主阿塔娜西亚，但她发现原著中公主的结局是被亲生父亲——暴君皇帝处死。为了改变命运，阿塔娜西亚开始努力争取父亲的爱。一段温馨又虐心的父女故事就此展开。',
    status: '已完结',
    chapters: 125,
    views: '5800万',
    tags: ['穿越', '古风', '亲情', '治愈'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '狂王',
    author: '金坎比 / 金珍奭',
    coverSeq: 'comic-cover-08',
    category: 'action',
    rating: 9.2,
    description: '在一个由力量决定一切的世界里，少年王太被自己的父亲——狂王抛弃在死亡之地。为了生存和复仇，他必须不断变强，挑战那些不可一世的强大对手，最终成为真正的王者。极致的热血格斗漫画。',
    status: '连载中',
    chapters: 167,
    views: '4100万',
    tags: ['格斗', '复仇', '热血', '成长'],
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '入赘女婿',
    author: '朴二',
    coverSeq: 'comic-cover-09',
    category: 'drama',
    rating: 9.1,
    description: '曾是特种兵的吴镇守，为了守护心爱之人的家族企业，隐姓埋名成为入赘女婿。他一方面要隐藏自己强大的身份，一方面要应对商场上的明争暗斗。一部结合了动作与都市剧情的精彩漫画。',
    status: '连载中',
    chapters: 210,
    views: '5600万',
    tags: ['都市', '逆袭', '动作', '爱情'],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '少女的世界',
    author: '毛美朗',
    coverSeq: 'comic-cover-10',
    category: 'school',
    rating: 9.0,
    description: '四个性格迥异的少女在同一所高中相遇，她们的友情在日常的点滴中慢慢滋长。每个人都有自己的烦恼和梦想，但她们互相扶持，一起度过青春最美好的时光。温暖治愈的校园友情漫画。',
    status: '已完结',
    chapters: 98,
    views: '3200万',
    tags: ['校园', '友情', '青春', '治愈'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '天才宝贝的笨蛋老爹',
    author: '石井',
    coverSeq: 'comic-cover-11',
    category: 'comedy',
    rating: 9.3,
    description: '世界上最强杀手一朝穿越成了小婴儿的爸爸。然而这个婴儿却拥有超越常人的智商，每天想办法坑爹。杀手爸爸每天被自己的天才宝贝耍得团团转，笑料百出的亲子喜剧就此登场。',
    status: '连载中',
    chapters: 89,
    views: '2800万',
    tags: ['搞笑', '穿越', '亲子', '日常'],
    isHot: false,
    isNew: true,
  },
  {
    id: 12,
    title: '神之塔',
    author: 'SIU',
    coverSeq: 'comic-cover-12',
    category: 'fantasy',
    rating: 9.6,
    description: '传说登上塔的顶端就能实现任何愿望。少年第二十五夜为了追寻唯一的伙伴蕾哈尔进入了神秘的高塔。在塔中他遇到了各色各样的伙伴与敌人，开始了惊心动魄的爬塔之旅。韩国现象级奇幻漫画，世界观宏大。',
    status: '连载中',
    chapters: 580,
    views: '2.1亿',
    tags: ['冒险', '奇幻', '战斗', '友情'],
    isHot: true,
    isNew: false,
  },
];